import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import "./style.css";
import { configuration } from "../appConfig";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class CarDentTable extends Component {
  state = {
    data: {},
    make: "",
    words: {},
    lang: "En",
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  componentDidMount() {
    // const partnerId = localStorage.getItem("partnerId");
    // const vin = localStorage.getItem("selectedFile");
    // Axios.get(
    //   `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    // ).then((r) => {
    //   if (r.data) {
    //     this.setState({ data: r.data });
    //   }
    // });
    this.getLang();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data!== this.props.data) {
      this.setState({data :this.props.data, make: this.props.data.Make});
    }
  }
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  render() {
    const client = localStorage.getItem('client');
    const { data, make } = this.state;
    function findWithAttr(array, attr, value) {
      for(var i = 0; i < array.length; i += 1) {
          if(array[i][attr] === value) {
              return i;
          }
      }
      return -1;
    }
    return (
      <div className="row p-0 text-muted hide-report">
        <div className="table-responsive">
          <table className="table table-bordered table-striped dent-table-2d text-center">
            <thead>
              <tr>
                <th>{this.lang("Part")}</th>
                <th>{this.lang("A")}</th>
                <th>{this.lang("B")}</th>
                <th>{(client === "SWISS" || client === "POLAND") ? this.lang('C') : this.lang("C")}</th>
                <th>{this.lang("Total")}</th>
              </tr>
            </thead>
            <tbody>
              {data.Dents &&
                data.Dents.length &&
                data.Dents.map((r, i) => {
                  if(r.Part === "Trunk" || r.Part === 'LeftFrontTyre' || r.Part === 'LeftBackTyre' || r.Part === 'RightFrontTyre' || r.Part === 'RightBackTyre' || r.Part === 'FrontBumper' || r.Part === 'BackBumper' || r.Part === 'Underbody' || r.Part === 'Inside') {
                    return
                  }
                  else {
                    return <>{
                      client === "POLAND" && make.toLowerCase() !== 'kia' && r.Part === "TrunkCover" ?
                      <tr key={i}>
                        <td style={{ textAlign: "left" }}>{this.lang(r.Part)}</td>
                        <td style={{}}>{r.A  + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A : 0 )}</td>
                        <td style={{}}>{r.B  + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B : 0 )}</td>
                        <td style={{}}>{r.C + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C : 0 )}</td>
                        <td style={{}}>{parseInt(r.A + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A : 0 )) + parseInt(r.B + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B : 0 )) +( r.C + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C : 0 )) }</td>
                      
                      </tr>
                    : client === "SWISS" && r.Part === "TrunkCover" ? 
                    <tr key={i}>
                        <td style={{ textAlign: "left" }}>{this.lang(r.Part)}</td>
                        <td style={{}}>{r.A  + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A : 0 )}</td>
                        <td style={{}}>{r.B  + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B : 0 )}</td>
                        <td style={{}}>{r.C + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C : 0 )}</td>
                        <td style={{}}>{parseInt(r.A + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].A : 0 )) + parseInt(r.B + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].B : 0 )) +( r.C + (data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C ? data.Dents[findWithAttr(data.Dents, 'Part', 'Trunk')].C : 0 )) }</td>
                      
                      </tr>
                       :
                    <tr key={i}>
                      <td style={{ textAlign: "left" }}>{this.lang(r.Part)}</td>
                      <td style={{}}>{r.A}</td>
                      <td style={{}}>{r.B}</td>
                      <td style={{}}>{r.C}</td>
                      <td style={{}}>{parseInt(r.A) + parseInt(r.B) + parseInt(r.C ? r.C : 0)}</td>
                    </tr>
                    }</>
                  }
                })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(CarDentTable);
